import React, {Component} from 'react';
import {Dialog} from "primereact/dialog";
import {Dropdown} from "primereact/dropdown";

export default class ModalIgnorar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            motivo: '',
            error: '',
        }
    }

    ignorarColeta = () => {
        const payload = {
            motivo: this.state.motivo,
            id: this.props.coletaSelecionada.id
        };

        this.props.ignorarColeta(payload);
    }

    render() {
        return (
            <Dialog
                style={{width: '50vw'}}
                position={'top'}
                modal
                onHide={this.props.onHide} visible={this.props.visible} header={"Ignorar Coleta"}>
                <div>
                    <div className="row form-group">
                        <div className="col-12">
                            <label htmlFor="motivo">Motivo</label>
                            <Dropdown
                                style={{width:'100%'}}
                                value={this.state.motivo}
                                appendTo={document.body}
                                onChange={(e) => this.setState({...this.state, motivo: e.target.value})}
                                options={this.props.options}
                                />

                        </div>
                    </div>

                    <div className="form-group row">
                        <div className="col-12">
                            <button disabled={this.state.motivo === ''} className="btn btn-sm btn-block btn-success" onClick={this.ignorarColeta}>
                                Ignorar Coleta
                            </button>
                        </div>
                    </div>
                </div>
            </Dialog>
        )
    }
}
